import { useEffect, useState, useContext } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Box, Typography, Backdrop, CircularProgress, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, IconButton, Dialog } from "@mui/material";
import { InsertDriveFileOutlined } from "@mui/icons-material";
import pdfMake from "pdfmake/build/pdfmake";
import {bord_versement} from "../asset/pdfmaker";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function VersHistory(props) {
    const { updateConnect } = useContext(Context)
    const [logs, setLogs] = useState([])
    const [load, setLoad] = useState(true)
    const [open, setOpen] = useState(false)
    const [pdf, setPdf] = useState()
    
    function get_bordereau(vers) {
        setLoad(true)
        fetch(API.concat(`/eglises/by/${JSON.stringify({isFederation: true})}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const pdfDocGenerator = pdfMake.createPdf(bord_versement(json[0], vers, props.vers.bordereau_num !== vers.bordereau_num, props.vers.bordereau_num));
                    pdfDocGenerator.getBlob((blob) => {
                        setPdf(URL.createObjectURL(blob))
                    });
                    setOpen(true);  
                }
                setLoad(false)
            }
        })
    }

    useEffect(()=>{
        fetch(API.concat(`/versements/${props.vers.num}/history`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const sorted = json.map(log => {
                        log.user = log.who.nom+' '+log.who.prenom1+(Boolean(log.who.prenom2)?' '+log.who.prenom2:'')
                        log.what = JSON.parse(log.what)
                        return log
                    })
                    .sort((a, b) => new Date(b.when).getTime() - new Date(a.when).getTime())
                    setLogs(sorted)
                }
                setLoad(false)
            }
        })
    }, [props, updateConnect])

    return(
        <Box style={{display:'flex', flexDirection:'column', margin:'10px'}} sx={{overflow:'auto'}} >
            <Typography sx={{textAlign:'center', marginY:'20px', fontSize:26}}>Historique</Typography>
            {logs && !load && <TableContainer sx={{maxHeight:'100%'}}>
                <Table
                aria-labelledby="tableTitle">
                    <TableHead>
                        <TableRow>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Date </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Utilisateur </TableCell>
                            <TableCell align='center' sx={{fontWeight:'bold'}} > Action </TableCell>
                            <TableCell ></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {logs.map((row, index) =>
                        <TableRow key={index} >
                            <TableCell align='center' sx={{minWidth:'70px'}}> {new Date(row.when).toLocaleDateString('fr-FR', {weekday: 'short',year: 'numeric', month: 'short',day: 'numeric'})} </TableCell>
                            <TableCell sx={{minWidth:'120px'}} style={{textTransform:'capitalize'}} align="center">{row.who.nom+' '+row.who.prenom1+' '+row.who.prenom2}</TableCell>
                            <TableCell sx={{minWidth:'100px'}} align="center">{row.action}</TableCell>
                            <TableCell><IconButton aria-label="Edit reçu" onClick={()=>get_bordereau(row.what)}><InsertDriveFileOutlined fontSize="small"/></IconButton></TableCell>
                        </TableRow>
                    )}
                    </TableBody>
                </Table>
            </TableContainer>}
            <Dialog open={open} onClose={()=>setOpen(false)} maxWidth='md' fullWidth>
                {pdf && <embed src={pdf} width='100%' height='600px' type="application/pdf" />}
            </Dialog>
            <Backdrop open={load}><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}